<template>
  <div class="my_video">
    <video-player
      class="video-player vjs-custom-skin v-player w-full h-full"
      :playsinline="true"
      ref="videoRef"
      @pause="pauseHandle($event)"
      @loadeddata="loadHandle($event)"
      @ended="endHandle($event)"
      :options="options"
      @timeupdate="timeHandle"
    ></video-player>
    <slot name="setNode" :slotProp="{ set: setCurrentTime, currentTime }"></slot>
  </div>
</template>

<script>
// import VideoPlayer from 'vue-video-player'
import { FileApi } from '@wiz-api/file-management'
import dayjs from 'dayjs'
import { videoPlayer } from 'vue-video-player'

const fileApi = new FileApi()
export default {
  name: 'video-command',
  components: {
    videoPlayer,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    fileId: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      options: {
        autoplay: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        loop: false,
        sources: [],
        poster: null,
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间
        },
      },
      videoUrl: '',
      currentTime: '',
      currentIndex: 0,
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
  },
  methods: {
    pauseHandle(player) {},
    loadHandle(player) {
      const time = Math.floor(player.duration())
      this.$emit('sentTime', time)
    },
    // 播放过程
    timeHandle(player) {
      const currentTime = Math.floor(player.currentTime())
    },
    // 设置当前时间
    setCurrentTime() {
      const currentTime = Math.floor(this.$refs.videoRef.player.currentTime())
      this.$refs.videoRef.player.pause()
      return currentTime
    },
    // 循环播放
    endHandle() {
      if (this.currentIndex >= this.fileId.length) return
      this.options.autoplay = true
      this.initData()
    },
    async initData() {
      // const [err, res] = await fileApi.download(this.fileId[this.currentIndex])
      // if (err) return
      // const blob = new Blob([res])
      // this.videoUrl = URL.createObjectURL(blob)
      this.videoUrl = `${this.fileUrl}${this.fileId[this.currentIndex]}/play-video`
      // console.log(this.videoUrl)
      if (this.currentIndex) {
        this.options.sources[0].src = this.videoUrl
      } else {
        this.options.sources.push({ src: this.videoUrl, type: 'video/mp4' })
      }
      this.currentIndex = this.currentIndex + 1
    },
  },
  created() {
    this.initData()
  },
}
</script>

<style scoped lang="scss">
@import '../../../../node_modules/vue-video-player/src/custom-theme.css';
@import '../../../../node_modules/video.js/dist/video-js.css';
.my_video {
  width: 500px;
  height: 300px;
}
</style>
